import styled from 'styled-components';

export const ContentInfoDescription = styled.div`
	font-size: 20px;
	line-height: 1.2;
	margin-bottom: 20px;
`;
